import { Injectable } from '@angular/core';
import { ProspectApiService } from '@core/services/api.services/prospect-api.service';
import { PaginatedResponseDto } from '@core/services/dto';
import { ProvinceModel } from '@shared/models';
import { ProspectCreate } from '@shared/models/prospect-create';
import { Observable } from 'rxjs';
import { ProspectProfileApiService } from '@core/services/api.services/prospect-profile-api.service';
import { Country } from '@core/services/dto/countryList.dto';
import { ApiResponse } from '@core/services/dto/api-response.dto';

@Injectable({
  providedIn: 'root'
})
export class CreateProspectStateService {

  constructor(
    private service: ProspectApiService,
    private prospectProfileService: ProspectProfileApiService,

  ) { }

  createProspect(prospect: ProspectCreate): Observable<any> {
    return this.service.createProspect(prospect);
  }

  getProvinces(): Observable<PaginatedResponseDto<ProvinceModel>> {
    return this.service.getProvinces();
  }

  getCountries(): Observable<Country[] | ApiResponse<Country[]>> {
    return this.prospectProfileService.getCountries();
  }

}


